import React from 'react';

const About = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>About Our College</h1>
      <p>We provide world-class education with a focus on innovation and excellence.</p>
      <ul>
        <li><strong>Location:</strong> City Campus, Tech District</li>
        <li><strong>Established:</strong> 1995</li>
        <li><strong>Accreditation:</strong> Grade A+</li>
      </ul>
    </div>
  );
};

export default About;
